import { render, staticRenderFns } from "./custom-group.vue?vue&type=template&id=26789f3d&scoped=true&"
import script from "./custom-group.vue?vue&type=script&lang=js&"
export * from "./custom-group.vue?vue&type=script&lang=js&"
import style0 from "./custom-group.vue?vue&type=style&index=0&id=26789f3d&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26789f3d",
  null
  
)

export default component.exports